import { render } from "./ContentEdit.vue?vue&type=template&id=f35e6548"
import script from "./ContentEdit.vue?vue&type=script&lang=js"
export * from "./ContentEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__